<template>
	<div class="product-page">
		<div class="search-layout">
			<div class="search-image">
				<!-- 显示已上传的图片 -->
				<div class="uploaded-images">
					<div class="uploaded-image-item" v-for="(image, index) in uploadedImages" :key="index"
						:style="{'border':image.checked?'3px solid #D9001B':''}">
						<img :src="image.isSetting ? image.newBase64 : image.url" alt="Uploaded Image"
							class="uploaded-image" @click="handleChangeUploadImage(image)">
						<button class="remove-image-btn" @click.stop="removeImage(index)">
							<i class="el-icon-close"></i>
						</button>
						<div class="manual-select" @click="setManualSelect(image)">{{ $t('manualSelect') }}</div>
						<!-- 搜索状态遮罩层 -->
						<div v-if="image.loadingStatus === 'waiting'" class="search-mask waiting">
							<div class="search-mask-content">
								<i class="el-icon-loading el-icon--right"></i>
								<span>{{ $t('waitingRecognition') }}</span>
							</div>
						</div>
						<div v-if="image.loadingStatus === 'searching'" class="search-mask searching">
							<div class="scan-line"></div>
							<div class="search-mask-content">
								<span>{{ $t('recognizingSearching') }}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 引入选择搜索区域组件 -->
				<SelectImageSearchArea :visible.sync="dialogVisible" :select-image="selectImage"
					@confirm="handleSelectionConfirm" @cancel="handleSelectionCancel" show-small />
			</div>
			<div class="search-image-tip">
				<div class="upload-button">
					<button class="custom-upload-btn" @click="triggerFileInput">
						<i class="el-icon-upload" style="font-size: 24px;"></i>
						<span>{{$t('uploadImage')}}</span>
					</button>
					<input type="file" ref="fileInput" class="file-input" accept="image/*" multiple
						@change="handleFileUpload">
				</div>
				<div style="margin-left: 10px;">
					<span
						style="font-size: 18px;font-weight: bold;color: #000;">{{uploadedImages.length}}/{{maxSize}}</span>
					<div style="display: flex;">
						<span>{{$t('searchImageTip')}}</span>
						<span class="search-image-remark" @click="moreSearch">{{$t('searchImageTip2')}}</span>
						<span>{{$t('searchImageTip3')}}</span>
					</div>
				</div>
			</div>
		</div>
		<!-- Search Bar -->
		<div class="search-container" :class="{ 'search-container-fixed': isSearchFixed }">
			<div class="search-wrapper">
				<div class="custom-search-input">
					<div class="search-icon"><i class="el-icon-search"></i></div>
					<el-input type="text" :placeholder="$t('searchPlaceholder')" v-model="searchKeyword"
						class="search-input" />
					<button class="search-button" @click="search">{{ $t('search') }}</button>
				</div>
			</div>
		</div>

		<div class="container" style="margin-top: 10px;">
			<!-- 查询条件区域 -->
			<div>
				<ProductSearchFilter ref="productSearchFilter" module="product" @filter-change="handleFilterChange"
					:platform-id="platform" />
			</div>
			<!-- 图片搜索结果商品列表 -->
			<div style="margin-top: 30px;">
				<ProductListForImage :goods="imageSearchProducts" :loading="searchStatus" @load-more="loadMore" />
			</div>
		</div>

		<SearchByImageDialog :visible.sync="searchByImageDialogVisible" />
		<RightFixedPanel @openEnquiry="enquiryDialogVisible = true" @openComplaint="complaintDialogVisible = true" />
		<EnquiryDialog :visible.sync="enquiryDialogVisible" />
		
		<ComplaintDialog :visible.sync="complaintDialogVisible" />
	</div>
</template>

<script>
	import ProductListForImage from '@/components/ProductListForImage.vue';
	import ProductSearchFilter from '@/components/ProductSearchFilter.vue';
	import SearchByImageDialog from '@/components/SearchByImageDialog.vue';
	import SelectImageSearchArea from '@/components/SelectImageSearchArea.vue';
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import EnquiryDialog from '@/components/EnquiryDialog.vue';
	import ComplaintDialog from '@/components/ComplaintDialog.vue';
	
	import goodsApi from '@/api/product';
	import {
		generateThumbnail
	} from '@/utils/searchImage';
	export default {
		name: 'ProductSearchByImage',
		components: {
			ProductListForImage,
			SearchByImageDialog,
			ProductSearchFilter,
			SelectImageSearchArea,
			RightFixedPanel,
			EnquiryDialog,
			ComplaintDialog
		},
		data() {
			return {
				enquiryDialogVisible: false,
				complaintDialogVisible: false,
				searchByImageDialogVisible: false,
				searchKeyword: '',
				isSearchFixed: false,
				isSearchFilterFixed: false,
				brand: "all",
				platform: "all",
				priceRange: "all",
				shipping: "all",
				sortBy: "inShowcase",
				uploadedImages: [],
				dialogVisible: false, //显示设置搜索区域弹窗
				maxSize: 6,
				selectImage: {}, //需要设置搜索区域的图片信息
				// 搜索流程控制
				isSearching: false,
				searchStatus: 'waiting',
				// 搜索结果存储，使用key作为唯一键值
				searchResults: {},
				// 搜索结果商品列表
				imageSearchProducts: []
			}
		},
		mounted() {
			// 从路由参数获取搜索关键词
			if (this.$route.query.keyword) {
				this.searchKeyword = this.$route.query.keyword
			}
			// 检查sessionStorage中是否有上传的文件
			this.checkForUploadedFiles();
			//加载查询条件
			if (this.$refs.productSearchFilter && typeof this.$refs.productSearchFilter.init === 'function') {
				this.$refs.productSearchFilter.init();
			}
			// 添加滚动事件监听器
			window.addEventListener('scroll', this.handleScroll)
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll)
			})
		},
		methods: {
			handleFilterChange(filter) {
				console.log(filter)
				this.brand = filter.brand;
				this.platform = filter.platform;
				this.priceRange = filter.priceRange;
				this.shipping = filter.shipping;
				this.sortBy = filter.sortBy;
				//加载商品信息
				setTimeout(() => {
					// 商品列表会通过imageSearchProducts自动更新
					console.log('筛选条件已更新:', filter);
				}, 200)
			},
			search() {
				window.open(`/product?keyword=${this.searchKeyword.trim()}`)
			},
			moreSearch() {
				this.searchByImageDialogVisible = true;
			},
			// 触发文件选择
			triggerFileInput() {
				this.$refs.fileInput.click();
			},
			// 处理文件上传
			handleFileUpload(event) {
				const files = event.target.files;
				if (files.length > 0) {
					// 处理文件并添加到上传列表
					this.addFilesToUploadList(files);
				}
			},
			// 添加文件到上传列表
			addFilesToUploadList(files) {
				// 计算剩余可上传数量
				const remainingSlots = this.maxSize - this.uploadedImages.length;
				if (remainingSlots <= 0) {
					// 已达到最大数量限制
					var tip = this.$t('maxUpload');
					this.$message.warning(tip.replace('{max}', this.maxSize));
					return;
				}

				// 限制上传数量
				const filesToAdd = Math.min(files.length, remainingSlots);

				// 处理每个文件
				for (let i = 0; i < filesToAdd; i++) {
					const file = files[i];
					// 创建文件URL用于预览
					const imageUrl = URL.createObjectURL(file);

					// 创建一个临时对象，先添加到数组
					const imageItem = {
						key: Math.floor(Math.random() * 10000000000),
						loadingStatus: 'waiting', //waiting等待搜索，searching搜索中，completed搜索完成，failed搜索失败
						checked: false,
						url: imageUrl,
						file: file,
						name: file.name,
						size: file.size,
						type: file.type,
						pageNumber: 1,
						base64: '', //原图base64
						newBase64: '', //存储搜索区域返回的base64
						isSetting: false //是否设置过搜索区域
					};
					this.uploadedImages.push(imageItem);

					// 转换文件为base64
					this.convertToBase64(file, (base64Data) => {
						// 更新base64数据
						imageItem.base64 = base64Data;
					});
				}

				if (filesToAdd < files.length) {
					var tip = this.$t('hasUpload');
					tip = tip.replace('{filesToAdd}', filesToAdd).replace('{max}', this.maxSize)
					this.$message.warning(tip);
				}

				// 处理选中状态和搜索
				this.processAfterFileAdd();
				console.log("图片数组", this.uploadedImages);
			},
			// 文件添加后处理
			processAfterFileAdd() {
				// 获取uploadedImages中checked为true的数据
				var checkedImages = this.uploadedImages.filter(item => item.checked);
				if (checkedImages.length == 0 && this.uploadedImages.length > 0) {
					this.uploadedImages[0].checked = true;
				}
				// 默认加载loadingStatus='waiting'的数据
				this.searchGoods();
			},
			// 移除图片
			removeImage(index) {
				// 获取要删除的图片对象
				const removedImage = this.uploadedImages[index];
				// 释放URL对象
				URL.revokeObjectURL(removedImage.url);
				// 从数组中移除
				this.uploadedImages.splice(index, 1);
				if (this.uploadedImages.length == 0) {
					this.searchStatus = 'waiting';
				}
				// 从searchResults中移除对应的搜索结果
				if (this.searchResults[removedImage.key]) {
					delete this.searchResults[removedImage.key];
					console.log('移除搜索结果:', removedImage.key);
				}

				// 处理移除图片后的选中状态和商品列表
				this.handleAfterImageRemove();
			},
			// 处理移除图片后的逻辑
			handleAfterImageRemove() {
				// 检查是否还有选中的图片
				const hasCheckedImage = this.uploadedImages.some(image => image.checked);
				if (!hasCheckedImage && this.uploadedImages.length > 0) {
					// 如果没有选中的图片，则默认选择第一张图
					this.uploadedImages[0].checked = true;
					// 更新商品列表为新选中图片的结果
					const newSelectedImage = this.uploadedImages[0];
					const newSearchResult = this.searchResults[newSelectedImage.key];
					if (newSearchResult && newSearchResult.result) {
						this.imageSearchProducts = newSearchResult.result.goodsPage.records;
					} else {
						this.imageSearchProducts = [];
					}
				} else if (this.uploadedImages.length === 0) {
					// 如果没有图片了，清空商品列表
					this.imageSearchProducts = [];
				}
			},
			// 设置图片搜索区域
			setManualSelect(image) {
				console.log("设置图片搜索区域", image)
				this.selectImage = image;
				this.dialogVisible = true;
			},
			// 处理选择确认
			handleSelectionConfirm(selectionData) {
				this.uploadedImages.forEach(element => {
					if (selectionData.key == element.key) {
						element.pageNumber = 1;
						element.region = selectionData.region;
						element.isSetting = true;
						element.newBase64 = selectionData.imageWithSelectionBase64;
						element.loadingStatus = 'waiting'; // 设置为等待搜索状态
					}
				})
				this.imageSearchProducts = [];

				this.uploadedImages = JSON.parse(JSON.stringify(this.uploadedImages))

				this.dialogVisible = false;
				// 开始搜索
				this.searchGoods();
				// 这里可以使用选择区域数据进行后续操作
			},
			// 处理选择取消
			handleSelectionCancel() {
				this.dialogVisible = false;
			},
			// 处理图片选中切换
			handleChangeUploadImage(selectedImage) {
				// 取消所有图片的选中状态
				this.uploadedImages.forEach(image => {
					image.checked = false;
				});
				// 设置当前点击图片为选中状态
				selectedImage.checked = true;
				// 从searchResults中获取该图片的搜索结果
				const searchResult = this.searchResults[selectedImage.key];
				if (searchResult && searchResult.result) {
					this.imageSearchProducts = searchResult.result.goodsPage.records;
				}
			},
			// 将文件转换为base64
			convertToBase64(file, callback) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const base64Data = e.target.result;
					if (callback) {
						callback(base64Data);
					}
				};
				reader.onerror = (error) => {
					console.error('转换失败:', error);
					if (callback) {
						callback('');
					}
				};
				reader.readAsDataURL(file);
			},
			// 检查sessionStorage中是否有上传的文件
			checkForUploadedFiles() {
				const uploadedFiles = sessionStorage.getItem('uploadedFiles');
				if (uploadedFiles) {
					try {
						const fileDataArray = JSON.parse(uploadedFiles);
						if (fileDataArray && fileDataArray.length > 0) {
							// 处理文件数据
							this.processUploadedFiles(fileDataArray);
							// 清除sessionStorage中的文件数据
							sessionStorage.removeItem('uploadedFiles');
						}
					} catch (error) {
						console.error('处理上传文件失败:', error);
						sessionStorage.removeItem('uploadedFiles');
					}
				}
			},
			// 处理从sessionStorage获取的文件数据
			processUploadedFiles(fileDataArray) {
				// 计算剩余可上传数量
				const remainingSlots = this.maxSize - this.uploadedImages.length;
				if (remainingSlots <= 0) {
					var tip = this.$t('maxUpload');
					this.$message.warning(tip.replace('{max}', this.maxSize));
					return;
				}

				// 限制上传数量
				const filesToAdd = Math.min(fileDataArray.length, remainingSlots);

				// 处理每个文件
				for (let i = 0; i < filesToAdd; i++) {
					const fileData = fileDataArray[i];

					// 创建一个临时对象，先添加到数组
					const imageItem = {
						key: Math.floor(Math.random() * 10000000000),
						loadingStatus: 'waiting', //waiting等待搜索，searching搜索中，completed搜索完成，failed搜索失败
						checked: false,
						url: fileData.url,
						name: fileData.name,
						size: fileData.size,
						type: fileData.type,
						base64: '', //原图base64
						newBase64: '', //存储搜索区域返回的base64
						isSetting: false //是否设置过搜索区域
					};
					this.uploadedImages.push(imageItem);

					// 将文件转换为base64
					this.convertBlobUrlToBase64(fileData.url, (base64Data) => {
						// 更新base64数据
						imageItem.base64 = base64Data;
					});
				}

				if (filesToAdd < fileDataArray.length) {
					var tip = this.$t('hasUpload');
					tip = tip.replace('{filesToAdd}', filesToAdd).replace('{max}', this.maxSize)
				}

				// 处理选中状态和搜索
				this.processAfterFileAdd();
				console.log("从Home页面上传的图片数组", this.uploadedImages);
			},
			// 将blob URL转换为base64格式
			convertBlobUrlToBase64(blobUrl, callback) {
				fetch(blobUrl)
					.then(response => response.blob())
					.then(blob => {
						const reader = new FileReader();
						reader.onload = (e) => {
							const base64Data = e.target.result;
							if (callback) {
								callback(base64Data);
							}
						};
						reader.onerror = (error) => {
							console.error('转换失败:', error);
							if (callback) {
								callback('');
							}
						};
						reader.readAsDataURL(blob);
					})
					.catch(error => {
						console.error('获取blob失败:', error);
						if (callback) {
							callback('');
						}
					});
			},
			// 优化后的搜索方法（串行请求）
			async searchGoods() {
				// 检查是否已有搜索流程在运行
				if (this.isSearching) return;

				// 过滤出需要搜索的图片（状态为waiting）
				const imagesToSearch = this.uploadedImages.filter(image => image.loadingStatus === 'waiting');
				if (imagesToSearch.length > 0) {
					// 标记搜索流程开始
					this.isSearching = true;
					this.searchStatus = 'searching'
					// 开始串行搜索
					await this.searchImagesSequentially(imagesToSearch, 0);
					// 所有图片搜索完成，标记搜索流程结束
					this.isSearching = false;
					this.searchStatus = 'finish';
				}
			},
			// 串行搜索图片
			async searchImagesSequentially(images, index) {
				if (index >= images.length) return;

				const image = images[index];
				// 更新状态为搜索中
				image.loadingStatus = 'searching';

				try {
					// 执行搜索
					const result = await this.searchGoodsByImage(image);
					// 更新状态为完成
					image.loadingStatus = 'completed';
					// 将搜索结果存储到searchResults对象中，使用key作为唯一键值
					this.searchResults[image.key] = result;
					// 每次搜索完成后，通过key获取对应的搜索结果并更新商品列表
					if (image.checked) {

						const searchResult = this.searchResults[image.key];
						if (searchResult && searchResult.result) {
							this.imageSearchProducts = searchResult.result.goodsPage.records;
							console.log('更新商品列表:', this.imageSearchProducts);
						}
					}
					image.multiRegion = result.result.picInfo.multiRegion;
					image.region = result.result.picInfo.region;
					image.newBase64 = await generateThumbnail(image.region, image.url);
					image.isSetting = image.newBase64 != '';
				} catch (error) {
					// 更新状态为失败
					image.loadingStatus = 'failed';
				}
				// 搜索下一张图片
				await this.searchImagesSequentially(images, index + 1);
			},
			// 根据图片搜索商品
			async searchGoodsByImage(image) {
				// 模拟网络请求延迟
				await new Promise(resolve => setTimeout(resolve, 1000));

				var data = {
					region: image.region || '',
					pageNumber: image.pageNumber,
					pageSize: 20,
					imageBase64: image.base64,
				};

				// 执行以图搜索查询
				const res = await goodsApi.getGoodsByImage(data);
				return res;
			},
			//下滑加载更多
			async loadMore() {
				try {
					// 找到当前选中的图片
					var selectImage = this.uploadedImages.find(image => image.checked);
					if (!selectImage) return;
					
					// 增加页码
					selectImage.pageNumber = (selectImage.pageNumber || 1) + 1;
					console.log("下一页", selectImage.pageNumber)
					
					// 构造搜索参数
					const data = {
						region: selectImage.region || '',
						pageNumber: selectImage.pageNumber,
						pageSize: 20,
						imageBase64: selectImage.base64,
					};

					// 执行搜索，获取下一页数据
					const res = await goodsApi.getGoodsByImage(data);

					// 检查搜索结果是否有效
					if (!res || !res.result || !res.result.goodsPage || !res.result.goodsPage.records) {
						console.error('搜索结果格式错误:', res);
						return;
					}

					// 获取现有搜索结果
					var searchResult = this.searchResults[selectImage.key];
					if (!searchResult || !searchResult.result || !searchResult.result.goodsPage) {
						// 如果没有现有搜索结果，使用新的搜索结果
						this.searchResults[selectImage.key] = res;
						this.imageSearchProducts = res.result.goodsPage.records;
					} else {
						// 合并商品列表
						const existingProducts = searchResult.result.goodsPage.records || [];
						const newProducts = res.result.goodsPage.records || [];
						const mergedProducts = [...existingProducts, ...newProducts];
						
						// 更新搜索结果
						searchResult.result.goodsPage.records = mergedProducts;
						this.imageSearchProducts = mergedProducts;
					}
					
				} catch (error) {
					console.error('加载更多数据失败:', error);
				} finally {}
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// 简单实现搜索框固定效果
				this.isSearchFixed = scrollTop > 100;
				this.isSearchFilterFixed = scrollTop > 160
			}
		},
	}
</script>

<style scoped>
	.product-page {
		padding: 0;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	/* Filter container styles */
	.filter-container {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		justify-content: space-between;
		margin: 20px 0;
	}

	.filter-container.filter-container-fixed {
		position: fixed !important;
		top: 40px !important;
		left: 0 !important;
		right: 0 !important;
		bottom: auto !important;
		z-index: 999 !important;
		background-color: #f2f2f2;
		padding: 15px 20px;
		justify-content: center;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
	}

	.filter-item {
		display: flex;
		flex-direction: column;
		gap: 5px;
		border: 1px solid #DCDFE6 !important;
		background: #F2F2F2;
		border-radius: 5px;
	}

	.filter-item label {
		font-weight: bold;
		font-size: 14px;
		color: #333;
	}

	.filter-select {
		width: 200px;
	}

	.search-layout {
		background-image: linear-gradient(to bottom, #016AF8, #fff);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.search-image {
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		max-width: 1200px;
		width: 100%;
		gap: 10px;
	}

	.uploaded-images {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	.uploaded-image-item {
		position: relative;
		width: 150px;
		height: 150px;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		overflow: hidden;
		background-color: #fff;
	}

	.uploaded-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 8px;
	}

	.manual-select {
		position: absolute;
		width: 150px;
		background-color: #016AF8;
		color: #fff;
		font-size: 15px;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 5px 0;
		cursor: pointer;
	}

	.remove-image-btn {
		position: absolute;
		top: 0;
		right: 0;
		background-color: #D9001B;
		color: white;
		border: none;
		width: 22px;
		height: 22px;
		border-radius: 0 0 0 4px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		z-index: 1;
	}

	/* 选中状态指示器 */
	.image-checked-indicator {
		position: absolute;
		top: 0;
		left: 0;
		background-color: #016AF8;
		color: white;
		border: none;
		width: 22px;
		height: 22px;
		border-radius: 0 0 4px 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		z-index: 1;
	}

	.uploaded-image {
		cursor: pointer;
	}

	/* 搜索状态遮罩层 */
	.search-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 5;
	}

	.search-mask.waiting {
		background-color: rgba(0, 0, 0, 0.35);
	}

	.search-mask.searching {
		background-color: rgba(245, 154, 35, 0.5);
		overflow: hidden;
	}

	/* 扫描线效果 */
	.scan-line {
		position: absolute;
		left: 0;
		width: 100%;
		height: 3px;
		background: linear-gradient(to right, transparent, #fff, transparent);
		box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
		animation: scan 2s ease-in-out infinite;
		z-index: 6;
	}

	@keyframes scan {
		0% {
			top: 0;
		}

		50% {
			top: 100%;
		}

		100% {
			top: 0;
		}
	}

	.search-mask-content {
		color: white;
		font-size: 14px;
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.search-mask-content .el-icon-loading {
		animation: rotate 1s linear infinite;
	}

	@keyframes rotate {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	.dialog-content-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;
	}

	.dialog-image-container {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #f5f7fa;
		border-radius: 4px;
		padding: 10px;
	}

	.dialog-canvas {
		max-width: 500px;
		max-height: 500px;
		cursor: crosshair;
	}

	.selection-box {
		position: absolute;
		border: 2px solid #016AF8;
		background-color: rgba(1, 106, 248, 0.2);
		cursor: move;
		z-index: 10;
	}

	.resize-handle {
		position: absolute;
		width: 8px;
		height: 8px;
		background-color: #016AF8;
		border: 1px solid white;
		cursor: pointer;
	}

	.resize-handle-tl {
		top: -4px;
		left: -4px;
		cursor: nwse-resize;
	}

	.resize-handle-tr {
		top: -4px;
		right: -4px;
		cursor: nesw-resize;
	}

	.resize-handle-bl {
		bottom: -4px;
		left: -4px;
		cursor: nesw-resize;
	}

	.resize-handle-br {
		bottom: -4px;
		right: -4px;
		cursor: nwse-resize;
	}

	.resize-handle-t {
		top: -4px;
		left: 50%;
		transform: translateX(-50%);
		cursor: ns-resize;
	}

	.resize-handle-r {
		right: -4px;
		top: 50%;
		transform: translateY(-50%);
		cursor: ew-resize;
	}

	.resize-handle-b {
		bottom: -4px;
		left: 50%;
		transform: translateX(-50%);
		cursor: ns-resize;
	}

	.resize-handle-l {
		left: -4px;
		top: 50%;
		transform: translateY(-50%);
		cursor: ew-resize;
	}

	.selection-actions {
		z-index: 100;
		padding: 10px;
		background: #f5f7fa;
		border-radius: 4px;
		width: 100%;
		max-width: 500px;
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}



	.search-image-tip {
		padding: 0 20px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		max-width: 1200px;
		width: 100%;
		gap: 10px;
		color: #666;
	}

	.search-image-remark {
		color: #016AF8;
		font-weight: bold;
		cursor: pointer;
	}

	.upload-button {
		position: relative;
	}

	.custom-upload-btn {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 15px 20px;
		background-color: #D9001B;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		font-size: 16px;
		transition: background-color 0.3s;
	}

	.custom-upload-btn:hover {
		background-color: #ff4400;
	}

	.file-input {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		z-index: 1;
	}

	/* Search bar styles */
	.search-container {
		display: flex;
		justify-content: center;
		z-index: 10;
		display: none;
	}

	.search-container.search-container-fixed {
		position: fixed !important;
		top: 0px !important;
		left: 0 !important;
		right: 0 !important;
		bottom: auto !important;
		z-index: 1000 !important;
		display: flex !important;
		background-color: white;
		padding: 10px;
	}

	.search-container.search-container-fixed .search-wrapper {
		background-color: white !important;
		padding: 10px;
	}

	.search-container.search-container-fixed .custom-search-input {
		width: 72%;
		border-color: #F59A23;
		background-color: rgba(0, 0, 0, 0.05);
	}

	.search-container.search-container-fixed .search-icon {
		height: 35px;
	}

	.search-container.search-container-fixed .search-button {
		height: 35px;
		width: 100px;
		font-size: 14px;
	}

	.search-container.search-container-fixed .image-search-button {
		height: 40px;
		padding: 0 15px;
		font-size: 14px;
	}

	.search-container.search-container-fixed :deep .el-input__inner {
		color: #333;
		height: 35px;
	}

	.search-container.search-container-fixed .search-icon {
		color: #909399;
	}

	.search-wrapper {
		background-color: #016AF8;
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: 10px;
	}

	.custom-search-input {
		display: flex;
		align-items: center;
		border-radius: 10px;
		width: 72%;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 0.35);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		border: 2px solid #F59A23;
	}

	.search-icon {
		padding: 0 0 0 15px;
		color: #909399;
		font-size: 18px;
		height: 40px;
		display: flex;
		align-items: center;
	}

	.search-button {
		background-color: #F59A23;
		color: white;
		border: none;
		height: 60px;
		width: 160px;
		cursor: pointer;
		font-size: 17px;
		transition: background-color 0.3s;
	}

	:deep .el-input__inner {
		background-color: transparent !important;
		border: 0 solid #DCDFE6;
		font-size: 16px;
	}

	/* :deep .el-input__inner {
		color: #000 !important;
		border: 1px solid #DCDFE6 !important;
		background: #F2F2F2;
	}
	
	:deep .el-form-item__label {
		margin-bottom: -18px;
	} */

	.search-button:hover {
		background-color: #F59A23;
	}

	.image-search-button {
		background-color: #D9001B;
		color: white;
		border: none;
		height: 65px;
		padding: 0 20px;
		cursor: pointer;
		font-size: 16px;
		display: flex;
		align-items: center;
		gap: 5px;
		border-radius: 10px;
		transition: background-color 0.3s;
		font-weight: bold;
	}

	.image-search-button:hover {
		background-color: #D9001B;
	}
</style>